import _ from 'lodash/fp'
import gql from 'graphql-tag'
import { all, call, put, takeLatest } from 'redux-saga/effects'

import { actions, types } from '../reducers/clubsList'

import { apolloClient } from '@fe/business/src/apollo'

import * as snack from './snackMessage'

//  ███████╗███████╗███████╗███████╗ ██████╗████████╗███████╗
//  ██╔════╝██╔════╝██╔════╝██╔════╝██╔════╝╚══██╔══╝██╔════╝
//  █████╗  █████╗  █████╗  █████╗  ██║        ██║   ███████╗
//  ██╔══╝  ██╔══╝  ██╔══╝  ██╔══╝  ██║        ██║   ╚════██║
//  ███████╗██║     ██║     ███████╗╚██████╗   ██║   ███████║
//  ╚══════╝╚═╝     ╚═╝     ╚══════╝ ╚═════╝   ╚═╝   ╚══════╝

// Reuses the already-ported ClubQuery.clubs (no new backend query needed for this shallow list)
const CLUBS_LIST_QUERY = gql`
  query ClubsList {
    ClubQuery {
      clubs {
        id
        name
        handle
        pro
        active
        customer
        address {
          countryCode
        }
      }
    }
  }
`

// flatten address.countryCode to match the legacy clubs-list shape the table/pages expect
const toShallowClub = club => _.flow(
  _.set('countryCode', _.get('address.countryCode', club)),
  _.unset('address')
)(club)

export function * loadClubsEffect () {
  try {
    const response = yield call([apolloClient, apolloClient.query], {
      query: CLUBS_LIST_QUERY,
      fetchPolicy: 'network-only'
    })
    const clubs = _.getOr([], 'data.ClubQuery.clubs', response)
    return _.map(toShallowClub, clubs)
  } catch (error) {
    return { error }
  }
}

//  ███████╗ █████╗  ██████╗  █████╗ ███████╗
//  ██╔════╝██╔══██╗██╔════╝ ██╔══██╗██╔════╝
//  ███████╗███████║██║  ███╗███████║███████╗
//  ╚════██║██╔══██║██║   ██║██╔══██║╚════██║
//  ███████║██║  ██║╚██████╔╝██║  ██║███████║
//  ╚══════╝╚═╝  ╚═╝ ╚═════╝ ╚═╝  ╚═╝╚══════╝

/**
 * takeLatest(types.LOAD_REQUEST, loadClubsFlow)
 */
export function * loadClubsListFlow ({ payload }) {
  const clubsList = yield call(loadClubsEffect, payload)
  if (clubsList.error) {
    yield put(actions.loadError(clubsList))
    yield snack.genericError(clubsList.error)
  } else {
    yield put(actions.loadSuccess(clubsList))
  }
}

export default function * () {
  return yield all([
    takeLatest(types.LOAD_REQUEST, loadClubsListFlow)
  ])
}
